enum ResponseCode {
    UNDEFINED = '?',
    CONNECTION_ERROR = 'CONNECTION_ERROR',
    REQUEST_CANCELED = 'REQUEST_CANCELED',
    GENERAL_SERVER_ERROR = '5xx',
    NOT_FOUND = '404.00',
    BAD_REQUEST = '400.00',
    INVALID_DATA = '400.01',
    AVAILABILITY_PRICE_LOWER_THAN_COST = '400.11'
}

export default ResponseCode;